import { CustomTableColumn } from "../models/custom-table-fields";

/**
 * Column config for the TCG "Test Suites" list (Design > Test Case Generator).
 * Header colors match the Figma design tokens (V - Dark Purple #1E2345).
 */
export const tcgTestSuiteColumns: CustomTableColumn[] = [
  {
    key: "testSuiteName",
    display_name: "Test Suites",
    headerStyles: { background: "#1e2345", color: "#ffffff", "font-weight": "700" },
  },
  {
    key: "llmName",
    display_name: "LLM Name",
    headerStyles: {
      background: "#1e2345",
      color: "#ffffff",
      "font-weight": "700",
      width: "20%",
    },
  },
  {
    key: "timestamp",
    display_name: "Timestamp",
    headerStyles: {
      background: "#1e2345",
      color: "#ffffff",
      "font-weight": "700",
      width: "20%",
    },
  },
  {
    key: "actionsLabel",
    display_name: "Actions",
    noBorderRight: true,
    headerStyles: {
      background: "#1e2345",
      color: "#ffffff",
      "font-weight": "700",
      width: "18%",
    },
    _config: {
      type: "link",
      name: "View Test Cases",
    },
  },
];
